import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { AppWrapper, AppWrapperHeading } from 'components';

import CouponBuilderV1 from './CouponBuilderV1';
import NavBar from 'containers/Dashboard/Components/NavBar';

const HEADER_HEIGHT = 84;

const CouponBuilderWrapper = ({ user }) => {
  // Keep this to ensure consistent header offset behavior
  useEffect(() => {
    document.body.classList.add('cbv2-offset-header');
    document.body.style.setProperty('--cbv2-header-h', `${HEADER_HEIGHT}px`);
    return () => {
      document.body.classList.remove('cbv2-offset-header');
      document.body.style.removeProperty('--cbv2-header-h');
    };
  }, []);

  const [activeNav, setActiveNav] = useState('Coupon Builder');
  const { id: routeCouponId } = useParams();
  const location = useLocation();
  const qs = new URLSearchParams(location.search);

  const mode = (qs.get('mode') || '').toLowerCase(); // 'edit' or ''
  const stepParam = Number(qs.get('step') || 0);

  const startAtStep =
    Number.isFinite(stepParam) && stepParam > 0 ? stepParam : undefined;

  const editCouponId =
    routeCouponId && /^\d+$/g.test(routeCouponId)
      ? Number(routeCouponId)
      : routeCouponId || null;

  const isEditMode = mode === 'edit' && Boolean(editCouponId);

  // Belt-and-suspenders: drop a one-time localStorage hint as backup
  useEffect(() => {
    try {
      if (isEditMode) {
        localStorage.setItem('cbv2_editMode', '1');
        if (startAtStep)
          localStorage.setItem('cbv2_forceStep', String(startAtStep));
        if (editCouponId != null)
          localStorage.setItem('cbv2_editCouponId', String(editCouponId));
      } else {
        localStorage.removeItem('cbv2_editMode');
        localStorage.removeItem('cbv2_forceStep');
        localStorage.removeItem('cbv2_editCouponId');
      }
    } catch {}
  }, [isEditMode, startAtStep, editCouponId]);

  useEffect(() => {
  return () => {
    localStorage.removeItem('cbv2_editMode');
    localStorage.removeItem('cbv2_editCouponId');
    localStorage.removeItem('cbv2_forceStep');
  };
}, []);

  return (
    <div
      // showHeader
      // showSideNav
      // showHeadingRow
      // headingRowRender={() => (
      //   <div className="d-flex justify-content-between align-items-center w-100">
      //     <AppWrapperHeading headingText="Coupon Builder" />
      //   </div>
      // )}
    >
      <NavBar />
      <div className="container-fluid bg-[linear-gradient(135deg,_#d9d7d8_0%,_#ddd9db_30%,_#e5dadd_65%,_#f0e3e5_100%)]">
        <CouponBuilderV1
          key={isEditMode ? `edit-${editCouponId}` : 'new'}
          user={user}
          startAtStep={startAtStep} // <- key: “jump to this step”
          isEditMode={isEditMode} // optional, if you want special edit behavior
          editCouponId={editCouponId} // optional, if you preload existing data
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  user:
    state.businessInfo?.data ||
    state.auth?.data?.user ||
    state.auth?.user ||
    null,
});

export default connect(mapStateToProps)(CouponBuilderWrapper);
